import apiClient from './axios.config';
import { API_ENDPOINTS } from '../../constants';

class FiscalYearAPI {
    /**
     * Get all fiscal years with filtering and pagination
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>} - Fiscal years list with pagination
     */
    async getAllFiscalYears(params = {}) {
        try {
            const response = await apiClient.get(API_ENDPOINTS.FISCAL_YEARS, { params });
            return response.data;
        } catch (error) {
            console.error('Get fiscal years error:', error);
            throw error;
        }
    }

    /**
     * Get fiscal year by ID
     * @param {number} id - Fiscal year ID
     * @returns {Promise<Object>} - Fiscal year details
     */
    async getFiscalYearById(id) {
        try {
            const response = await apiClient.get(`${API_ENDPOINTS.FISCAL_YEARS}/${id}`);
            return response.data;
        } catch (error) {
            console.error('Get fiscal year by ID error:', error);
            throw error;
        }
    }

    /**
     * Get current active fiscal year
     * @returns {Promise<Object>} - Current fiscal year
     */
    async getCurrentFiscalYear() {
        try {
            const response = await apiClient.get(`${API_ENDPOINTS.FISCAL_YEARS}/current`);
            return response.data;
        } catch (error) {
            console.error('Get current fiscal year error:', error);
            throw error;
        }
    }

    /**
     * Create a new fiscal year
     * @param {Object} fiscalYearData - Fiscal year data
     * @returns {Promise<Object>} - Created fiscal year
     */
    async createFiscalYear(fiscalYearData) {
        try {
            const response = await apiClient.post(API_ENDPOINTS.FISCAL_YEARS, fiscalYearData);
            return response.data;
        } catch (error) {
            console.error('Create fiscal year error:', error);
            throw error;
        }
    }

    /**
     * Update fiscal year
     * @param {number} id - Fiscal year ID
     * @param {Object} fiscalYearData - Updated fiscal year data
     * @returns {Promise<Object>} - Updated fiscal year
     */
    async updateFiscalYear(id, fiscalYearData) {
        try {
            const response = await apiClient.put(`${API_ENDPOINTS.FISCAL_YEARS}/${id}`, fiscalYearData);
            return response.data;
        } catch (error) {
            console.error('Update fiscal year error:', error);
            throw error;
        }
    }

    /**
     * Activate fiscal year (set as current)
     * @param {number} id - Fiscal year ID
     * @returns {Promise<Object>} - Activated fiscal year
     */
    async activateFiscalYear(id) {
        try {
            const response = await apiClient.post(`${API_ENDPOINTS.FISCAL_YEARS}/${id}/activate`);
            return response.data;
        } catch (error) {
            console.error('Activate fiscal year error:', error);
            throw error;
        }
    }

    /**
     * Delete fiscal year
     * @param {number} id - Fiscal year ID
     * @returns {Promise<Object>} - Deletion result
     */
    async deleteFiscalYear(id) {
        try {
            const response = await apiClient.delete(`${API_ENDPOINTS.FISCAL_YEARS}/${id}`);
            return response.data;
        } catch (error) {
            console.error('Delete fiscal year error:', error);
            throw error;
        }
    }

    /**
     * Get quarters for a fiscal year
     * @param {number} fiscalYearId - Fiscal year ID
     * @returns {Promise<Object>} - Quarters list
     */
    async getQuarters(fiscalYearId) {
        try {
            const response = await apiClient.get(`${API_ENDPOINTS.FISCAL_YEARS}/${fiscalYearId}/quarters`);
            return response.data;
        } catch (error) {
            console.error('Get quarters error:', error);
            throw error;
        }
    }
}

const fiscalYearAPI = new FiscalYearAPI();
export default fiscalYearAPI;

